import { useState, useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";
import { t } from "i18next";

import TableListStore from "@/shared/components/organisms/TableListStore";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { TabsUser } from "@/shared/components/organisms/TabsUser";

import { useLessonsUserQuery } from "@/app/lessons/lessons.api";
import { UserStore } from "./userStore";
import { useGetUserInfoQuery, useUserQuery } from "@/app/users/users.api";

export const StoreAssignment = ({ branch_id, userShowData }: any) => {
  const { id } = useParams();
  const { data: user } = useGetUserInfoQuery({ id });
  const [idBranch, setIdBranch] = useState(0);
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));

  useEffect(() => {
    if (branch_id) {
      setIdBranch(branch_id);
    }
  }, [branch_id]);

  //TABS TIENDA
  const [selectedTabT, setSelectedTabT] = useState(1);
  const tabsT = [{ id: 1, name: t("kpi.views.Tienda") }];
  const handleTabChangeT = (tabId: any) => {
    setSelectedTabT(tabId);
  };

  return (
    <>
      <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10  mb-5 md:mb-3">
        {t("kpi.views.Tienda")}
      </h1>
      {/*       <TabsUser
        tabs={tabsT}
        selectedTab={selectedTabT}
        handleTabChange={handleTabChangeT}
        button={
          <ButtonSoft text={t("kpi.views.Tienda")} size="large" />
        }
      /> */}

      <UserStore id={user?.data?.user?.branch?.id} user_current={user?.data?.user}  onOpenStock={() => {}} />
      {/*  {selectedTabT === 1 ? (
        <TableListStore store={userShowData.history ?? []} />
      ) : null} */}
    </>
  );
};
